import DOMPurify from "dompurify";

/**
 * Безпечне санітайз HTML-стрічок з backend перед `dangerouslySetInnerHTML`.
 *
 * Дозволені тільки basic-форматувальні теги що використовуються в Telegram
 * HTML-режимі. Все інше (script, iframe, на події, стилі, посилання
 * `javascript:` тощо) — вирізається.
 *
 * Це Critical мітигація з security-аудиту (#2): API повертає content
 * урока/спікера/become-speaker з 1.0 DB. На фазі міграції з legacy
 * SQLite до Postgres може потрапити шкідливий HTML — без sanitization
 * це повноцінний XSS у Mini App (можна exfiltrate `initData`).
 */
const ALLOWED_TAGS = [
  "b",
  "strong",
  "i",
  "em",
  "u",
  "s",
  "strike",
  "del",
  "br",
  "p",
  "code",
  "pre",
  "blockquote",
  "span",
  "a",
];

const ALLOWED_ATTR = ["href", "target", "rel"];

export function sanitizeHtml(raw: string | null | undefined): string {
  if (!raw) return "";
  return DOMPurify.sanitize(raw, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // Принудительно target=_blank rel=noopener noreferrer для <a>
    ADD_ATTR: ["target"],
    ALLOW_DATA_ATTR: false,
  });
}
